import React, { useState } from "react";
import { useQuery} from "react-query";
import { useNavigate, useLocation} from "react-router-dom";
import { getMembers } from "../../../api/apiServices";
import MemberSearchBar from "../../Common/Search/MemberSearchBar";
import UserRoles from "../../../hooks/userRoles";
import useAuth from "../../../hooks/useAuth";
import jwt_decode from "jwt-decode";
import toast, { Toaster } from "react-hot-toast";
const titles = ["MR.", "MR", "MRS.", "MISS"];

const FindMember = () => {
	const { auth } = useAuth();
	const decoded = auth?.accessToken
		? jwt_decode(auth.accessToken)
		: undefined;

	const role = decoded?.UserInfo?.role || "";

	const navigate = useNavigate();
	const location = useLocation();
	const from = location.state?.from?.pathname || "/";

	const [search, setSearch] = useState(false);
	const [member, setMember] = useState([]);
	const [country, setCountry] = useState("gh");

	const [searchCriteria, setSearchCriteria] = useState({
		pf_number: "",
		mobile_number: "",
		first_name: "",
		last_name: "",
	});

	const { data: members } = useQuery("members", getMembers);

	const handleCancel = () => {
		setSearchCriteria({
			pf_number: "",
			mobile_number: "",
			first_name: "",
			last_name: "",
		});
		setCountry("gh");
		setSearch(false);
		navigate(from, { replace: true });
	};

	const handleUpdateRecord = (id) => {
		if (role === UserRoles.SuperAdmin || role === UserRoles.SystemAdmin) {
			navigate(`/update_member/${id}`);
		} else {
			toast.error(
				"You are not authorized to perform this function. Contact the System Administrator",
				{
					duration: 3000,
					className: "toast-message",
				}
			);
			return false;
		}
	};

	let content;
	if (search) {
		content =
			member && member?.length <= 0 ? (
				<div className="table-responsive lg">
					<table className="table table-bordered">
						<tbody>
							<tr>
								<td
									style={{
										fontSize: "20px",
										fontWeight: "700",
										color: "#000",
										textAlign: "center",
									}}
								>
									No member found with the requested
									parameter(s)
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			) : (
				<div className="table-responsive lg">
					<table className="table table-borderless table-hover table-striped">
						<thead className="align">
							<tr>
								<th scope="col">#</th>
								<th scope="col">PF Number</th>
								<th scope="col">Full Name</th>
								<th scope="col">Region</th>
								<th scope="col">Mobile Number</th>
								<th scope="col">Email</th>
								<th scope="col">Action</th>
							</tr>
						</thead>
						<tbody>
							{member?.map((mem, index) => (
								<tr key={index}>
									<td>{index + 1}</td>
									<td>{mem.pf_number}</td>
									{titles.includes(mem.title) ? (
										<td style={{ whiteSpace: "nowrap" }}>
											{mem.first_name.toUpperCase()}&nbsp;
											{mem.middle_name.toUpperCase()}
											&nbsp;{mem.last_name.toUpperCase()}
										</td>
									) : (
										<td style={{ whiteSpace: "nowrap" }}>
											{mem.title.toUpperCase()}&nbsp;
											{mem.first_name.toUpperCase()}&nbsp;
											{mem.middle_name.toUpperCase()}
											&nbsp;{mem.last_name.toUpperCase()}
										</td>
									)}
									<td style={{ whiteSpace: "nowrap" }}>
										{mem.region}
									</td>
									<td style={{ whiteSpace: "nowrap" }}>
										{mem.mobile_number}
									</td>
									<td>{mem.email}</td>
									<td style={{ whiteSpace: "nowrap" }}>
										<div
											style={{
												display: "inline-block",
												whiteSpace: "nowrap",
											}}
										>
											<button
												onClick={() =>
													handleUpdateRecord(mem.id)
												}
												className="btn btn-danger"
											>
												<i className="fa fa-edit"></i>{" "}
												Update Record
											</button>
										</div>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			);
	}
	return (
		<>
			<section className="content-header">
				<Toaster toastOptions={{ position: "top-center" }} />
				<h1>Member Updates</h1>
			</section>
			<section className="content">
				<div className="box">
					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-12">
										<h4 className="panel-title">
											<MemberSearchBar
												members={members}
												setSearch={setSearch}
												setSearchCriteria={
													setSearchCriteria
												}
												setMember={setMember}
												country={country}
											/>
										</h4>
									</div>
								</div>
							</div>

							<div className="panel-body">{content}</div>
							{search ? (
								<div className="panel-footer">
									<div className="search-group">
										<button
											type="submit"
											className="btn btn-danger "
											onClick={handleCancel}
										>
											{" "}
											<i className="fa fa-search"></i>{" "}
											Cancel
										</button>
									</div>
								</div>
							) : null}
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default FindMember;
